import { render, staticRenderFns } from "./specialMenuPanel.vue?vue&type=template&id=40bee64c&scoped=true&lang=pug"
import script from "./specialMenuPanel.vue?vue&type=script&lang=js"
export * from "./specialMenuPanel.vue?vue&type=script&lang=js"
import style0 from "./specialMenuPanel.vue?vue&type=style&index=0&id=40bee64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bee64c",
  null
  
)

export default component.exports